/**
 * pointsConfig — shared constants for F1 points systems across eras.
 *
 * Fastest-lap bonus point:
 *   Introduced 2019, removed 2025.
 *   In 2019–2024 the driver who set the race fastest lap receives +1 point
 *   if they finished in the top 10. (Jolpica already includes this in
 *   its points field; OpenF1 and Livetiming paths apply it in code.)
 */
export const FL_BONUS_YEARS = {
  2019: true, 2020: true, 2021: true,
  2022: true, 2023: true, 2024: true,
};

/** Points awarded per finishing position (top 10, modern system). */
export const POINTS_TABLE = [25, 18, 15, 12, 10, 8, 6, 4, 2, 1];
